// extracted by mini-css-extract-plugin
export default {"guide":"PublicationsLegend__guide-Ezboh","status":"PublicationsLegend__status-q8cy9"};